import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { Panel } from '@/ui/atoms/panel/Panel'

export function LeaderboardSkeleton() {
  return (
    <Panel.Wrapper className="flex flex-1 flex-col items-start gap-2 px-6 py-4">
      {/* Table header */}
      <Skeleton className="mb-4 h-6 w-32" />

      {/* Table structure */}
      <div className="w-full">
        {/* Table headers */}
        <div className="mb-4 grid grid-cols-[1fr_2fr_1fr] gap-4 md:grid-cols-[1fr_2fr_2fr_1fr]">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-12" />
          <Skeleton className="hidden h-4 w-20 md:block" />
          <div className="flex justify-end">
            <Skeleton className="h-4 w-24" />
          </div>
        </div>

        {/* Table rows */}
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="mb-3 grid grid-cols-[1fr_2fr_1fr] gap-4 md:grid-cols-[1fr_2fr_2fr_1fr]">
            {/* Ranking */}
            <Skeleton className="h-5 w-4" />

            {/* User address */}
            <Skeleton className="h-5 w-24" />

            {/* Buddy code with copy button - hidden on mobile */}
            <div className="hidden items-center gap-2 md:flex">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-4 w-4 rounded" />
            </div>

            {/* Total buddies - aligned to right */}
            <div className="flex justify-center md:justify-end">
              <Skeleton className="h-5 w-8" />
            </div>
          </div>
        ))}
      </div>
    </Panel.Wrapper>
  )
}
